module.exports = __webpack_public_path__ + "static/media/axis_of_polarization_00086.8d6a4e53.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/en/axis_of_polarization_00086.png
// module id = 816
// module chunks = 0